import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { NavigationHistoryService } from "../services/navigation-history-service";

export const useSaveCurrentNavigation = ({ key }) => {
  const { pathname, search } = useLocation();
  const fullPath = `${pathname}${search}`;

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save(key, fullPath);
  }, [fullPath]);
};
